import { useEffect, useState } from 'react'

import { get } from '@js/common/api'

import { API_URL } from '@f-fertighaus/applications/Next/api/url'
import { APIResponse } from '@f-fertighaus/applications/Next/types/APIResponse'
import { HouseDetail } from '@f-fertighaus/applications/Next/types/houseDetailsResponse'
import { Nullable } from '@f-fertighaus/applications/Next/types/utility'

type Status = 'idle' | 'loading' | 'success'

interface PopularVendorHousesState {
  status: Status
  data: Nullable<HouseDetail[]>
}

export function usePopularVendorHousesData(
  vendorNid: string,
  limit: number
): PopularVendorHousesState {
  const [state, setState] = useState<PopularVendorHousesState>({
    status: 'idle',
    data: null
  })

  useEffect(() => {
    setState(prev => ({ ...prev, status: 'loading' }))

    get(API_URL.otherHousesByVendor(vendorNid, limit)).then(
      (response: APIResponse<HouseDetail>) => {
        setState({
          status: 'success',
          data: response.results
        })
      }
    )
  }, [vendorNid, limit])

  return state
}
